import { type Guard, type GuardStatus, UserCredentials, useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { CredentialGuard } from '@capsicum/socios-core-web';
import { useNonCustodialProviderUserWalletStatus } from '@socios-blk/core';
import { useEffect, useState } from 'react';

export const useNonCustodialOnboardingGuard: Guard = () => {
	const { areSettingsLoading, settings } = useSettings();
	const [status, setStatus] = useState<GuardStatus>('loading');
	const { push } = useRouter();
	const isPoblanoEnabled = !!settings?.isPoblanoEnabled;
	const { errorCode, isError, isLoading } = useNonCustodialProviderUserWalletStatus();
	const { status: credentialStatus } = CredentialGuard(UserCredentials.NCW_CREATE)();

	const NonCustodialUserNotFound = isError && errorCode === 404;

	useEffect(() => {
		if (areSettingsLoading) {
			setStatus('loading');
		}

		if (!isPoblanoEnabled) {
			return setStatus('denied');
		}

		return setStatus('allowed');
	}, [isLoading, areSettingsLoading, setStatus, NonCustodialUserNotFound, credentialStatus]);

	return {
		onDenied: () => push('/wallet'),
		status: status
	};
};
